import React from "react";
import { Users, TrendingUp, GraduationCap } from "lucide-react";

const SummaryCards = ({ analytics, loading, error }) => {
  const cards = [
    {
      label: "Active Students",
      value: analytics?.activeStudents?.toLocaleString() || "0",
      icon: <Users className="w-5 h-5 text-indigo-600" />,
      color: "green",
    },
    {
      label: "Average Completion Rate",
      value: `${analytics?.completionRate || 0}%`,
      icon: <TrendingUp className="w-5 h-5 text-indigo-600" />,
      color: "green",
    },
    {
      label: "Average Assessment Score",
      value: `${analytics?.averageScore || 0}%`,
      icon: <GraduationCap className="w-5 h-5 text-indigo-600" />,
      color: "amber",
    },
  ];

  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5 mb-6">
        {[1, 2, 3].map((idx) => (
          <div
            key={idx}
            className="bg-white border border-gray-200 rounded-lg shadow-sm p-4"
          >
            <div className="flex justify-between items-center mb-2">
              <div className="h-4 bg-gray-200 rounded animate-pulse w-24"></div>
              <div className="h-8 w-8 rounded-full bg-gray-200 animate-pulse"></div>
            </div>
            <div className="h-8 bg-gray-200 rounded animate-pulse mb-1"></div>
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5 mb-6">
        {[1, 2, 3].map((idx) => (
          <div
            key={idx}
            className="bg-white border border-gray-200 rounded-lg shadow-sm p-4"
          >
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-sm font-medium text-gray-500">Error</h3>
              <div className="h-8 w-8 rounded-full bg-red-100 flex items-center justify-center">
                <div className="w-5 h-5 text-red-600">!</div>
              </div>
            </div>
            <p className="text-2xl font-bold text-red-600">Error</p>
            <div className="flex items-center mt-1">
              <span className="text-sm text-red-600 font-medium">
                Failed to load data
              </span>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5 mb-6">
      {cards.map((card, idx) => (
        <div
          key={idx}
          className="bg-white border border-gray-200 rounded-lg shadow-sm p-4"
        >
          <div className="flex justify-between items-center mb-2">
            <h3 className="text-sm font-medium text-gray-500">{card.label}</h3>
            <div className="h-8 w-8 rounded-full bg-indigo-100 flex items-center justify-center">
              {card.icon}
            </div>
          </div>
          <p className="text-2xl font-bold text-gray-900">{card.value}</p>
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;
